import { gql, TypedDocumentNode } from '@apollo/client'
import type { UserDashboardQuery } from './__generated__/UserDashboardQuery'

export const userDashboardQuery: TypedDocumentNode<UserDashboardQuery> = gql`
  query UserDashboardQuery {
    userDashboard {
      contractNotReadyCount
      extensionCandidatesCount
      openedSurveysCount
      unpaidInvoicesCount
    }
  }
`
